var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Axios from 'axios';
import { observable, action } from 'mobx';
import { setCookie } from '../utils/Cookie';
export class LoginStore {
    constructor(rootStore) {
        this.email = '';
        this.password = '';
        this.hasError = false;
        this.loading = false;
        this.showPasswordMenu = false;
        this.rootStore = rootStore;
    }
    onChange(key, value) {
        this[key] = value;
    }
    onShowPasswordMenu() {
        this.showPasswordMenu = !this.showPasswordMenu;
    }
    onKeyDown(e) {
        if (e === 13) {
            this.onLogin();
        }
    }
    onLogin() {
        this.loading = true;
        const credentials = {
            userId: this.email,
            password: this.password,
            userType: 'Company'
        };
        return Axios.post(`https://${window.tfoEnv}user-service.tofindout.se/api/authentication/password-login`, credentials)
            .then(({ data }) => {
            data.lastActivity = new Date();
            setCookie(JSON.stringify(data));
            // FIXME!!! Initilization is brittle, make stores listen to each other
            this.rootStore.login().catch(console.error);
        })
            .catch(() => {
            return Axios.post(`https://${window.tfoEnv}user-service.tofindout.se/api/authentication/redirect-customer-login`, credentials)
                .then(r => {
                window.location.href = r.data;
            })
                .catch(() => {
                this.hasError = true;
            });
        })
            .finally(() => {
            this.loading = false;
        });
    }
}
__decorate([
    observable
], LoginStore.prototype, "email", void 0);
__decorate([
    observable
], LoginStore.prototype, "password", void 0);
__decorate([
    observable
], LoginStore.prototype, "rootStore", void 0);
__decorate([
    observable
], LoginStore.prototype, "hasError", void 0);
__decorate([
    observable
], LoginStore.prototype, "loading", void 0);
__decorate([
    observable
], LoginStore.prototype, "showPasswordMenu", void 0);
__decorate([
    action
], LoginStore.prototype, "onChange", null);
__decorate([
    action
], LoginStore.prototype, "onShowPasswordMenu", null);
__decorate([
    action
], LoginStore.prototype, "onKeyDown", null);
__decorate([
    action
], LoginStore.prototype, "onLogin", null);
